import { render, staticRenderFns } from "./SupportDialog.vue?vue&type=template&id=f17d65e2"
import script from "./SupportDialog.vue?vue&type=script&lang=js"
export * from "./SupportDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports